// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

import { useState, type ReactNode } from 'react'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import ListItemText from '@mui/material/ListItemText'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { MoreVertical } from 'lucide-react'

export interface MenuAction { key: string; label: string; hint?: string; onClick: () => void; danger?: boolean; dividerBefore?: boolean }

/** D-UI-3 — a row's "⋮" menu. Each action may carry a one-line hint of what it will do. */
export default function ActionMenu({ label, actions, icon }: { label: string; actions: MenuAction[]; icon?: ReactNode }) {
  const [el, setEl] = useState<HTMLElement | null>(null)
  return (
    <>
      <IconButton size="small" aria-label={label} onClick={e => setEl(e.currentTarget)}>{icon ?? <MoreVertical size={16} />}</IconButton>
      <Menu anchorEl={el} open={!!el} onClose={() => setEl(null)}>
        {actions.flatMap(a => [
          ...(a.dividerBefore ? [<Divider key={`${a.key}-divider`} />] : []),
          <MenuItem key={a.key} onClick={() => { setEl(null); a.onClick() }} sx={a.danger ? { color: 'error.main' } : undefined}>
            <ListItemText primary={a.label} secondary={a.hint} />
          </MenuItem>,
        ])}
      </Menu>
    </>
  )
}
